import React from 'react'
import { connect } from 'react-redux'
import { get } from 'lodash'

import { makeGetCustomer } from '../../store/Customer/selector'

import SuitesCustomerDetails from '../../containers/Customer/Details'
import Layout from '../../components/Layout'

export const CustomerDetails = ({ customer }) => {
  return (
    <Layout isSidebar={true} title={customer.name} backTo='/customers'>
      <SuitesCustomerDetails />
    </Layout>
  )
}

const mapStateToProps = (state, ownProps) => {
  const customerId = get(ownProps, 'match.params.id')
  const getCustomer = makeGetCustomer()
  const customer = getCustomer(state, customerId)

  return { customer }
}

export default connect(mapStateToProps, null)(CustomerDetails)
